import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BackendHttpInterceptor } from './backend-http-interceptor';
import { HandoverDetailAbandonComponent } from './components/handover-detail-abandon/handover-detail-abandon.component';
import { HandoverDetailAnnulusSpacesComponent } from './components/handover-detail-annulus-spaces/handover-detail-annulus-spaces.component';
import { HandoverDetailInjectorWellsComponent } from './components/handover-detail-annulus-spaces/handover-detail-injector-wells/handover-detail-injector-wells.component';
import { HandoverDetailMandrilComponent } from './components/handover-detail-annulus-spaces/handover-detail-mandril/handover-detail-mandril.component';
import { HandoverDetailCementingIcpComponent } from './components/handover-detail-cementing/handover-detail-cementing-icp/handover-detail-cementing-icp.component';
import { HandoverDetailCementingComponent } from './components/handover-detail-cementing/handover-detail-cementing.component';
import { HandoverDetailFooterEmitterComponent } from './components/handover-detail-footer-emitter/handover-detail-footer-emitter.component';
import { HandoverDetailFooterEmittersComponent } from './components/handover-detail-footer-emitters/handover-detail-footer-emitters.component';
import { HandoverDetailFooterReceiverComponent } from './components/handover-detail-footer-receiver/handover-detail-footer-receiver.component';
import { HandoverDetailFooterReceiversComponent } from './components/handover-detail-footer-receivers/handover-detail-footer-receivers.component';
import { HandoverDetailFooterViewComponent } from './components/handover-detail-footer-view/handover-detail-footer-view.component';
import { HandoverDetailAcidificationStimulationsComponent } from './components/handover-detail-fracture/handover-detail-acidification-stimulations/handover-detail-acidification-stimulations.component';
import { HandoverDetailFractureStimulationsComponent } from './components/handover-detail-fracture/handover-detail-fracture-stimulations/handover-detail-fracture-stimulations.component';
import { HandoverDetailFractureComponent } from './components/handover-detail-fracture/handover-detail-fracture.component';
import { HandoverDetailGeneralComponent } from './components/handover-detail-general/handover-detail-general.component';
import { HandoverDetailLocationImagesComponent } from './components/handover-detail-location/handover-detail-location-images/handover-detail-location-images.component';
import { HandoverDetailLocationStatusComponent } from './components/handover-detail-location/handover-detail-location-status/handover-detail-location-status.component';
import { HandoverDetailLocationWellheadImagesComponent } from './components/handover-detail-location/handover-detail-location-wellhead-images/handover-detail-location-wellhead-images/handover-detail-location-wellhead-images.component';
import { HandoverDetailLocationComponent } from './components/handover-detail-location/handover-detail-location.component';
import { HandoverDetailPerforationIcpComponent } from './components/handover-detail-perforation/handover-detail-perforation-icp/handover-detail-perforation-icp.component';
import { HandoverDetailPerforationComponent } from './components/handover-detail-perforation/handover-detail-perforation.component';
import { HandoverDetailProductionColumnComponent } from './components/handover-detail-production-column/handover-detail-production-column.component';
import { HandoverDetailProfilesComponent } from './components/handover-detail-profiles/handover-detail-profiles.component';
import { HandoverDetailSchematicComponent } from './components/handover-detail-schematic/handover-detail-schematic.component';
import { HandoverDetailSectionCommentComponent } from './components/handover-detail-section-comment/handover-detail-section-comment.component';
import { HandoverDetailAbandonmentReportComponent } from './components/handover-detail-status-notifications/handover-detail-abandonment-report/handover-detail-abandonment-report.component';
import { HandoverDetailExecutiveSummaryComponent } from './components/handover-detail-status-notifications/handover-detail-executive-summary/handover-detail-executive-summary.component';
import { HandoverDetailNotificationsComponent } from './components/handover-detail-status-notifications/handover-detail-notifications/handover-detail-notifications.component';
import { HandoverDetailStatusNotificationsComponent } from './components/handover-detail-status-notifications/handover-detail-status-notifications.component';
import { HandoverDetailStatusComponent } from './components/handover-detail-status-notifications/handover-detail-status/handover-detail-status.component';
import { HandoverDetailTestsComponent } from './components/handover-detail-tests/handover-detail-tests.component';
import { HandoverDetailTreeComponent } from './components/handover-detail-tree/handover-detail-tree.component';
import { HandoverDetailWellArchitectureComponent } from './components/handover-detail-well-architecture/handover-detail-well-architecture.component';
import { HandoverDetailWellIntegrityBarrierElementIssuesComponent } from './components/handover-detail-well-integrity/handover-detail-well-integrity-barrier-element-issues/handover-detail-well-integrity-barrier-element-issues.component';
import { HandoverDetailWellIntegrityRisksAlertsComponent } from './components/handover-detail-well-integrity/handover-detail-well-integrity-risks-alerts/handover-detail-well-integrity-risks-alerts.component';
import { HandoverDetailWellIntegrityTubingWearComponent } from './components/handover-detail-well-integrity/handover-detail-well-integrity-tubing-wear/handover-detail-well-integrity-tubing-wear.component';
import { HandoverDetailWellIntegrityComponent } from './components/handover-detail-well-integrity/handover-detail-well-integrity.component';
import { HandoverDetailWellheadSchemeComponent } from './components/handover-detail-wellhead/handover-detail-wellhead-scheme/handover-detail-wellhead-scheme.component';
import { HandoverDetailWellheadComponent } from './components/handover-detail-wellhead/handover-detail-wellhead.component';
import { HandoverDetailComponent } from './components/handover-detail/handover-detail.component';
import { HandoverDetailExecutiveResumeComponent } from './components/handover-detail-executive-resume/handover-detail-executive-resume.component';
import { HandoverHistoryDialogComponent } from './components/handover-history/handover-history-dialog/handover-history-dialog.component';
import { HandoverHistoryComponent } from './components/handover-history/handover-history.component';
import { HandoverImageComponent } from './components/handover-image/handover-image.component';
import { HandoverInitiateWellListComponent } from './components/handover-initiate/handover-initiate-well-list/handover-initiate-well-list.component';
import { HandoverInitiateWellSearchComponent } from './components/handover-initiate/handover-initiate-well-search/handover-initiate-well-search.component';
import { HandoverInitiateComponent } from './components/handover-initiate/handover-initiate.component';
import { HeaderComponent } from './components/header/header.component';
import { HandoverCardComponent } from './components/home/handover-card/handover-card.component';
import { HomeContentInboxEditionTeamComponent } from './components/home/home-content/home-content-inbox-edition-team/home-content-inbox-edition-team.component';
import { HomeContentInboxEditionComponent } from './components/home/home-content/home-content-inbox-edition/home-content-inbox-edition.component';
import { HomeContentInboxGeneralComponent } from './components/home/home-content/home-content-inbox-general/home-content-inbox-general.component';
import { HomeContentInboxPersonalComponent } from './components/home/home-content/home-content-inbox-personal/home-content-inbox-personal.component';
import { HomeContentInboxTeamComponent } from './components/home/home-content/home-content-inbox-team/home-content-inbox-team.component';
import { HomeContentRejectedTeamComponent } from './components/home/home-content/home-content-rejected-team/home-content-rejected-team.component';
import { HomeContentSentPersonalComponent } from './components/home/home-content/home-content-sent-personal/home-content-sent-personal.component';
import { HomeContentSentRejectedComponent } from './components/home/home-content/home-content-sent-rejected/home-content-sent-rejected.component';
import { HomeContentSentTeamComponent } from './components/home/home-content/home-content-sent-team/home-content-sent-team.component';
import { HomeContentComponent } from './components/home/home-content/home-content.component';
import { HomeSearchComponent } from './components/home/home-search/home-search.component';
import { HomeComponent } from './components/home/home.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ConfirmDialogComponent } from './components/shared/confirm-dialog/confirm-dialog.component';
import { DigitOnlyDirective } from './components/shared/directives/digit-only.directive';
import { ErrorComponent } from './components/shared/error/error.component';
import { ExportDataDialogComponent } from './components/shared/export-data-dialog/export-data-dialog.component';
import { HandoverDetailCommentsComponent } from './components/shared/handover-detail-comments/handover-detail-comments.component';
import { HandoverHistoryObservationsDialogComponent } from './components/shared/handover-history-observations-dialog/handover-history-observations-dialog.component';
import { ImageUploadComponent } from './components/shared/image-upload/image-upload.component';
import { Scatter3dChartComponent } from './components/shared/scatter3d-chart/scatter3d-chart.component';
import { HighlightPipe } from './highlight.pipe';
import { MaterialModule } from './material/material.module';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { HttpTokenInterceptor } from './shared/interceptors/http-token.interceptor';
import { initializer } from './shared/utils/auth.init';
export const isMock = environment.mock;

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    HandoverInitiateComponent,
    HandoverDetailComponent,
    HandoverDetailGeneralComponent,
    HandoverDetailWellArchitectureComponent,
    HandoverInitiateWellListComponent,
    HandoverInitiateWellSearchComponent,
    HighlightPipe,
    HandoverDetailProfilesComponent,
    HandoverDetailCementingComponent,
    HomeComponent,
    HandoverDetailCommentsComponent,
    HandoverDetailAnnulusSpacesComponent,
    ConfirmDialogComponent,
    HandoverDetailWellheadSchemeComponent,
    HandoverDetailWellheadComponent,
    HandoverDetailTreeComponent,
    ImageUploadComponent,
    HandoverImageComponent,
    HomeSearchComponent,
    HomeContentComponent,
    HomeContentInboxGeneralComponent,
    HomeContentInboxPersonalComponent,
    HomeContentInboxEditionComponent,
    HomeContentSentRejectedComponent,
    HomeContentSentPersonalComponent,
    HandoverDetailPerforationComponent,
    HandoverCardComponent,
    HandoverDetailAbandonComponent,
    HandoverDetailFooterReceiverComponent,
    HandoverDetailFooterReceiversComponent,
    HandoverDetailSchematicComponent,
    HandoverDetailSectionCommentComponent,
    HandoverDetailProductionColumnComponent,
    HandoverDetailFooterEmitterComponent,
    HandoverDetailWellIntegrityComponent,
    HomeContentInboxTeamComponent,
    HomeContentInboxEditionTeamComponent,
    HandoverDetailWellIntegrityBarrierElementIssuesComponent,
    HandoverDetailStatusNotificationsComponent,
    HandoverDetailStatusComponent,
    HandoverDetailWellIntegrityTubingWearComponent,
    HandoverHistoryObservationsDialogComponent,
    HandoverDetailFooterViewComponent,
    HandoverHistoryComponent,
    HandoverHistoryDialogComponent,
    HandoverDetailNotificationsComponent,
    ErrorComponent,
    ExportDataDialogComponent,
    DigitOnlyDirective,
    HandoverDetailInjectorWellsComponent,
    HandoverDetailMandrilComponent,
    HandoverDetailLocationComponent,
    HandoverDetailLocationStatusComponent,
    HandoverDetailLocationImagesComponent,
    HandoverDetailWellIntegrityRisksAlertsComponent,
    HandoverDetailFooterEmittersComponent,
    HandoverDetailExecutiveSummaryComponent,
    HandoverDetailFractureComponent,
    HomeContentRejectedTeamComponent,
    HomeContentSentTeamComponent,
    HandoverDetailLocationWellheadImagesComponent,
    Scatter3dChartComponent,
    HandoverDetailAbandonmentReportComponent,
    HandoverDetailFractureStimulationsComponent,
    HandoverDetailAcidificationStimulationsComponent,
    HandoverDetailPerforationIcpComponent,
    HandoverDetailTestsComponent,
    HandoverDetailCementingIcpComponent,
    HandoverDetailExecutiveResumeComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    FormsModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    KeycloakAngularModule,
    HttpClientModule,
  ],
  providers: isMock
    ? [
        AuthService,
        provideAppInitializer(() => {
          const initializerFn = initializer(
            inject(KeycloakService),
            inject(UserService)
          );
          return initializerFn();
        }),
        {
          provide: HTTP_INTERCEPTORS,
          useClass: BackendHttpInterceptor,
          multi: true,
        },
      ]
    : [
        AuthService,
        provideAppInitializer(() => {
          const initializerFn = initializer(
            inject(KeycloakService),
            inject(UserService)
          );
          return initializerFn();
        }),
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpTokenInterceptor,
          multi: true,
        },
        DatePipe,
      ],
  bootstrap: [AppComponent],
})
export class AppModule {}
